<template>
  <section class="invoice-add-wrapper">
    <b-row class="invoice-add">
      <!-- Col: Left (Invoice Container) -->
      <b-col cols="12" xl="9" md="8">
        <validation-observer ref="quote">
          <b-form @submit.prevent>
            <b-card no-body class="invoice-preview-card">
              <!-- Header -->
              <b-card-body class="invoice-padding pb-0">
                <div class="row align-items-center mb-2">
                  <div class="col-md-1">
                    <Logo />
                  </div>
                  <div class="col-9">
                    <div class="">
                      <CompanyName />
                    </div>
                    <div class="">
                      <Address />
                    </div>
                  </div>
                </div>
                <hr class="invoice-spacing" />

                <div class="invoice-padding pt-0">
                  <div class="invoice-spacing">
                    <!-- Col: Invoice To -->
                    <b-col cols="6" xl="6" class="mb-lg-1">
                      <validation-provider
                        rules="required"
                        v-slot="{ errors }"
                        name="Customer"
                        vid="Customer"
                      >
                        <b-form-group
                          label="Send Invoice To:*"
                          label-for="h-First"
                        >
                          <v-select
                            v-model="leadClientId"
                            :options="optionsCustomer"
                            label="text"
                            :reduce="(option) => option.value"
                            :clearable="false"
                            :searchable="true"
                            class="customer-selector"
                            placeholder="Search and select customer"
                            @input="customerSelected"
                          >
                            <template #option="option">
                              <div
                                class="customer-option"
                                v-b-tooltip.hover
                                :title="option.text"
                              >
                                {{ option.text }}
                              </div>
                            </template>
                            <template #selected-option="option">
                              <div
                                class="selected-customer"
                                v-b-tooltip.hover
                                :title="option.text"
                              >
                                {{ option.text }}
                              </div>
                            </template>
                          </v-select>
                          <small v-if="errors.length" class="text-danger">{{
                            errors[0]
                          }}</small>
                        </b-form-group>
                      </validation-provider>
                      <!-- Selected Client -->

                      <div v-if="whenSelected !== null" class="mt-1">
                        <b-card-text
                          class="mb-25 text-truncate"
                          v-b-tooltip.hover.bottom
                          :title="
                            whenSelected.otherName +
                            ' ' +
                            (whenSelected.surname || '')
                          "
                        >
                          {{
                            whenSelected.otherName +
                            " " +
                            (whenSelected.surname == null
                              ? " "
                              : whenSelected.surname)
                          }}
                        </b-card-text>

                        <b-card-text class="mb-25">
                          {{
                            whenSelected.addressLine2 == null
                              ? ""
                              : whenSelected.addressLine2 + ", "
                          }}
                          {{
                            whenSelected.addressLine1 == null
                              ? ""
                              : whenSelected.addressLine1 + " "
                          }}
                        </b-card-text>
                        <b-card-text class="mb-25">
                          {{ whenSelected.city }}
                          <!-- {{ customerProfile(leadClientId) }} -->
                        </b-card-text>
                        <b-card-text class="mb-25">
                          {{ whenSelected.tel }}
                        </b-card-text>
                        <b-card-text class="mb-0">
                          {{ whenSelected.email }}
                        </b-card-text>
                      </div>
                      <!-- <span v-if="!leadClientId" class="text-danger d-block ">Please select a person to send quote</span> -->
                    </b-col>
                  </div>
                </div>
                <!-- Header: Right Content -->
                <div
                  class="invoice-number-date mt-md-0 mt-2 d-flex flex-column align-items-end"
                >
                  <div
                    class="d-flex align-items-center justify-content-md-end mb-1"
                  >
                    <h4 class="invoice-title">Invoice No</h4>
                  </div>
                  <div class="d-flex align-items-center mb-1">
                    <span class="title"> Date: </span>
                    <flat-pickr
                      style="width: 100px"
                      v-model="issuedDate"
                      class="form-control invoice-edit-input"
                      :config="config.wrap"
                    />
                  </div>
                  <div class="mb-1">
                    <validation-provider
                      rules="required"
                      v-slot="{ errors }"
                      name="Due Date"
                      vid="Due Date"
                    >
                      <div class="d-flex align-items-center">
                        <span class="title"> Due Date:* </span>
                        <div>
                          <flat-pickr
                            style="width: 100px"
                            v-model="dueDate"
                            id="dueDate"
                            class="form-control invoice-edit-input"
                            :config="configDue.wrap"
                          />
                          <small v-if="errors.length" class="text-danger">{{
                            errors[0]
                          }}</small>
                        </div>
                      </div>
                    </validation-provider>
                  </div>

                  <div class="d-flex align-items-center mb-1">
                    <span class="title"> Select Currency:* </span>

                    <b-form-select
                      id="currencySelect"
                      v-model="selectedCurrency"
                      :options="currencyOptions"
                      style="width: 100px"
                      @change="validateCurrencyRate"
                    />
                  </div>
                  <div
                    class="d-flex align-items-center mb-1"
                    v-if="selectedCurrency !== 'MUR'"
                  >
                    <span class="title"> Enter rate:* </span>

                    <validation-provider
                      rules="required|min_value:0.01"
                      v-slot="{ errors }"
                      name="Rate"
                      vid="Rate"
                    >
                      <b-form-input
                        id="exchangeRate"
                        v-model="exchangeRate"
                        placeholder="Enter rate"
                        type="number"
                        style="width: 100px"
                        @onkeydown="numericValidation(event)"
                        @blur="updateInvoiceDataOnRateChange"
                      />
                      <small v-if="errors.length" class="text-danger">{{
                        errors[0]
                      }}</small>
                    </validation-provider>
                  </div>
                </div>
              </b-card-body>

              <!-- Spacer -->
              <hr class="invoice-spacing" />

              <!-- Invoice Client & Payment Details -->
              <b-card-body class="invoice-padding pt-0"> </b-card-body>

              <!-- Items Section -->
              <b-card-body class="invoice-padding">
                <div
                  ref="form"
                  class="repeater-form"
                  :style="{ height: trHeight }"
                >
                  <b-row
                    v-for="(item, index) in invoiceData.items"
                    :key="index"
                    ref="row"
                    class="pb-2"
                  >
                    <!-- Item Form -->
                    <!-- ? This will be in loop => So consider below markup for single item -->
                    <b-col cols="12">
                      <!-- ? Flex to keep separate width for XIcon and SettingsIcon -->
                      <!-- Form Input Fields OR content inside bordered area  -->
                      <!-- ? Flex to keep separate width for XIcon and SettingsIcon -->
                      <div class="d-flex border rounded">
                        <div>
                          <b-row class="flex-grow-1 px-2 pt-2">
                            <!-- Single Item Form Headers -->
                            <b-col cols="12" :lg="vat ? 6 : 8">
                              <label class="static-label">Items*</label>
                              <div
                                v-if="newProd"
                                class="d-flex justify-content-center"
                              >
                                <b-spinner variant="primary"></b-spinner>
                              </div>
                              <div v-else class="d-flex">
                                <div class="flex-grow-1 mr-1">
                                  <validation-provider
                                    rules="required"
                                    v-slot="{ errors }"
                                    name="Item"
                                    :vid="`Item${index}`"
                                  >
                                    <div class="d-flex align-items-center">
                                      <div class="flex-grow-1 mr-1">
                                        <v-select
                                          v-model="item.id"
                                          :options="optionsProduct"
                                          label="itemTitle"
                                          :dir="
                                            $store.state.appConfig.isRTL
                                              ? 'rtl'
                                              : 'ltr'
                                          "
                                          :clearable="false"
                                          :searchable="true"
                                          class="item-selector-title"
                                          placeholder="Select Item"
                                          @input="
                                            (val) =>
                                              updateItemForm(
                                                index,
                                                val,
                                                exchangeRate,
                                                selectedCurrency
                                              )
                                          "
                                        >
                                          <template
                                            #option="{
                                              itemTitle,
                                              categoryName,
                                              subCategoryName,
                                            }"
                                          >
                                            <div
                                              style="
                                                display: flex;
                                                flex-direction: column;
                                              "
                                              v-b-tooltip.hover.bottom="
                                                itemTitle &&
                                                itemTitle.length > 8
                                                  ? itemTitle
                                                  : ''
                                              "
                                            >
                                              <span>
                                                {{ itemTitle }}
                                              </span>
                                              <span>
                                                {{ categoryName || "-" }} :
                                                {{ subCategoryName || "-" }}
                                              </span>
                                            </div>
                                          </template>
                                        </v-select>
                                      </div>
                                    </div>
                                    <small
                                      v-if="errors.length"
                                      class="text-danger"
                                      >{{ errors[0] }}</small
                                    >
                                  </validation-provider>
                                </div>

                                <div d-flex>
                                  <!-- Button Add Item -->
                                  <b-button
                                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                    v-b-modal.modal-addProduct
                                    variant="primary"
                                    size="md"
                                  >
                                    +
                                  </b-button>
                                </div>
                              </div>
                              <!-- <span v-if="!item.id" class="text-danger" >Item is required</span> -->
                            </b-col>

                            <b-col cols="12" lg="2">
                              <label class="static-label"
                                >Unit Price ({{ selectedCurrencySign }})*</label
                              >
                              <b-form-input
                                v-model="item.cost"
                                type="text"
                                class="mb-2"
                                @keypress="allowOnlyNumbersUnitPrice"
                                @paste="cleanNumberInput($event, index)"
                                @input="cleanNumberInput($event, index)"
                              />
                            </b-col>

                            <b-col cols="12" lg="2" v-if="vat">
                              <label class="static-label"> VAT (%)</label>
                              <b-form-input
                                v-model="item.tax"
                                type="number"
                                class="mb-2"
                                @keypress="allowOnlyNumbers($event)"
                              />
                            </b-col>
                            <b-col cols="12" lg="2">
                              <div
                                class="d-flex align-items-center justify-content-between"
                              >
                                <div class="flex-grow-1">
                                  <label class="static-label">Qty*</label>
                                  <validation-provider
                                    rules="required|min_value:0.00001"
                                    v-slot="{ errors }"
                                    name="Quantity"
                                    :vid="`Quantity_${index}`"
                                  >
                                    <b-form-input
                                      v-model="item.qty"
                                      type="number"
                                      class="mb-2"
                                      @keypress="allowOnlyNumbers($event)"
                                    />
                                    <small
                                      v-if="errors.length"
                                      class="text-danger"
                                      >{{ errors[0] }}</small
                                    >
                                  </validation-provider>
                                </div>
                              </div>
                              <div class="mb-1">
                                <b-button
                                  variant="danger"
                                  size="sm"
                                  @click="removeItem(index)"
                                >
                                  Remove
                                </b-button>
                              </div>
                            </b-col>

                            <b-col cols="12" lg="12">
                              <span class="d-inline d-lg-none"
                                >Description</span
                              >
                              <b-form-textarea
                                v-model="item.description"
                                class="mb-2 mb-lg-0"
                              />
                            </b-col>
                            <!-- Col: Discount Type -->
                            <!-- <b-col
                              cols="12"
                              md="4"
                              class="mt-md-0 mt-3 d-flex align-items-center"
                            >
                              <span
                                for="invoice-discount-type"
                                class="text-nowrap mr-50"
                                >Discount Type:</span
                              >
                              <b-form-select
                                id="invoice-discount-type"
                                v-model="item.discountType"
                                :options="discountTypeOptions"
                              />
                            </b-col> -->

                            <!-- Col: Discount Value -->
                            <!-- <b-col
                              cols="12"
                              md="3"
                              class="mt-md-0 mt-3 d-flex align-items-center"
                            >
                              <span
                                for="invoice-discount-value"
                                class="text-nowrap mr-50"
                                >Discount Value:</span
                              >
                              <validation-provider rules="min_value:0" v-slot="{ errors }" name="Discount"
                                :vid="`Discount_${index}`">
                                <b-form-input id="invoice-discount-value" v-model="item.discount" type="number"
                                  @input="validateDiscount(index)" @blur="ensureNotNull(index)" />
                                <small v-if="errors.length" class="text-danger">{{ errors[0] }}</small>
                              </validation-provider>
                            </b-col> -->
                          </b-row>
                          <hr />
                        </div>
                      </div>
                    </b-col>
                  </b-row>
                </div>

                <b-row class="align-items-center">
                  <b-col md="2">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      size="sm"
                      variant="primary"
                      class="mr-2"
                      @click="addNewItemInItemForm"
                    >
                      Add Item
                    </b-button>
                  </b-col>
                  <b-col md="3">
                    <b-input-group>
                      <b-form-input
                        v-model="barcode"
                        placeholder="Enter Barcode"
                        @keydown.enter="addItemWithBarcode"
                      />
                      <b-input-group-append is-text>
                        <feather-icon icon="CastIcon" />
                      </b-input-group-append>
                    </b-input-group>

                    <b-modal
                      id="modal-barcode"
                      title="Select Product"
                      ok-only
                      ok-title="Cancel"
                      centered
                    >
                      <div v-if="selectedProduct">
                        <b-form-radio-group
                          v-model="selectedRadioValue"
                          :options="productOptions"
                          name="product-radio"
                          @change="addProductFromModal(selectedRadioValue)"
                          stacked
                        >
                        </b-form-radio-group>
                      </div>
                    </b-modal>
                  </b-col>
                </b-row>
              </b-card-body>

              <!-- Invoice Description: Total -->
              <b-card-body class="invoice-padding pb-0">
                <b-row>
                  <!-- Col: Sales Persion -->
                  <b-col
                    cols="12"
                    md="4"
                    class="mt-md-0 mt-3"
                    order="2"
                    order-md="1"
                  >
                    <div class="w-100 mb-2">
                      <span
                        for="invoice-data-sales-person"
                        class="text-nowrap mr-50"
                        >Sales Person:*</span
                      >
                      <validation-provider
  rules="required"
  v-slot="{ errors }"
  name="Sales Person"
  vid="Sales Person"
>
  <v-select
    v-model="salesPersonId"
    :options="optionsSalesPerson"
    label="text"
    :reduce="option => option.value"
    :clearable="false"
    :searchable="true"
    placeholder="Select Sales Person"
  >
    <!-- Dropdown option -->
    <template #option="{ value }">
      <div
        class="customer-option"
        v-b-tooltip.hover
        :title="getSalesPersonName(value)"
      >
        {{ getSalesPersonName(value) }}
      </div>
    </template>

    <!-- Selected option -->
    <template #selected-option="{ value }">
      <div
        class="selected-customer"
        v-b-tooltip.hover
        :title="getSalesPersonName(value)"
      >
        {{ getSalesPersonName(value) }}
      </div>
    </template>
  </v-select>

  <small v-if="errors.length" class="text-danger">
    {{ errors[0] }}
  </small>
</validation-provider>
                    </div>
                    <div class="w-100">
                      <span
                        for="invoice-data-warehouse"
                        class="text-nowrap mr-50"
                        >Choose Warehouse:*</span
                      >
                      <validation-provider
                        rules="required"
                        v-slot="{ errors }"
                        name="Warehouse"
                        vid="Warehouse"
                      >
                        <v-select
                          id="warehouse"
                          v-model="warehouseId"
                          :options="optionsWarehouse"
                          label="text"
                          :reduce="(option) => option.value"
                          :clearable="false"
                          :searchable="true"
                          placeholder="Select Warehouse"
                        >
                          <!-- Dropdown options -->
                          <template #option="{ text }">
                            <div
                              class="warehouse-option"
                              v-b-tooltip.hover
                              :title="text"
                            >
                              {{ text }}
                            </div>
                          </template>

                          <!-- Selected option -->
                          <template #selected-option="{ text }">
                            <div
                              class="selected-warehouse"
                              v-b-tooltip.hover
                              :title="text"
                            >
                              {{ text }}
                            </div>
                          </template>
                        </v-select>

                        <!-- Validation error -->
                        <small v-if="errors.length" class="text-danger">{{
                          errors[0]
                        }}</small>
                      </validation-provider>
                    </div>
                  </b-col>

                  <!-- Col: Warehouse (added below Sales Person) -->

                  <!-- Col: Total -->

                  <b-col
                    cols="12"
                    md="8"
                    class="mt-md-6 d-flex justify-content-end"
                    order="1"
                    order-md="2"
                  >
                    <div class="invoice-total-wrapper">
                      <b-row>
                        <b-col> Discount Rate: </b-col>
                        <b-col>
                          <validation-provider
                            :rules="`min_value:0|max_value:${maxDiscountValue}`"
                            v-slot="{ errors }"
                            name="Discount"
                            :vid="`Discount_${index}`"
                          >
                            <b-form-input
                              id="invoice-discount-value"
                              v-model="MainDiscount"
                              type="number"
                              :placeholder="discountPlaceholder"
                              @blur="ensureMainDiscountNotNull"
                            />
                            <small v-if="errors.length" class="text-danger">{{
                              errors[0]
                            }}</small>
                          </validation-provider>
                        </b-col>
                      </b-row>
                      <div class="invoice-total-item mt-1">
                        <p class="invoice-total-title">Discount:</p>
                        <p class="invoice-total-amount">
                          {{ selectedCurrencySign }}
                          {{ discountTotal.toFixed(2) }}
                        </p>
                      </div>
                      <div class="invoice-total-item">
                        <p class="invoice-total-title">Subtotal:</p>
                        <p class="invoice-total-amount">
                          {{ selectedCurrencySign }} {{ subTotal.toFixed(2) }}
                        </p>
                      </div>

                      <div class="invoice-total-item" v-if="vat">
                        <p class="invoice-total-title">VAT:</p>
                        <p class="invoice-total-amount">
                          {{ selectedCurrencySign }} {{ VATtotal.toFixed(2) }}
                        </p>
                      </div>

                      <hr class="my-50" />
                      <div class="invoice-total-item">
                        <p class="invoice-total-title">Total:</p>
                        <p class="invoice-total-amount">
                          {{ selectedCurrencySign }} {{ finalTotal }}
                        </p>
                      </div>
                    </div>
                  </b-col>
                </b-row>
              </b-card-body>

              <!-- Spacer -->
              <hr class="invoice-spacing" />

              <!-- Note -->
              <b-card-body class="invoice-padding pt-0">
                <span class="font-weight-bold">Note: </span>
                <b-form-textarea v-model="note" />
              </b-card-body>
            </b-card>
          </b-form>
        </validation-observer>

        <validation-observer ref="addProduct">
          <!-- modal Add Item-->
          <b-modal
            id="modal-addProduct"
            :hide-footer="true"
            ref="addProductModal"
            centered
            title="Add Product"
          >
            <b-form @submit.prevent="handleProdSubmit">
              <b-row>
                <b-col cols="12">
                  <b-form-group>
                    <label for="name">Name:</label>
                    <validation-provider
                      rules="required"
                      #default="{ errors }"
                      name="name"
                    >
                      <b-form-input
                        id="name"
                        type="text"
                        placeholder="Name"
                        v-model="prodName"
                        required
                      />
                      <small
                        v-if="errors.length"
                        class="text-danger text-end"
                        >{{ errors[0] }}</small
                      >
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <b-form-group>
                    <label for="qty">Quantity:</label>
                    <validation-provider
                      rules="required"
                      #default="{ errors }"
                      name="qty"
                    >
                      <b-form-input
                        id="qty"
                        type="number"
                        placeholder="Quantity"
                        v-model="prodQty"
                        required
                        @keypress="allowOnlyNumbersProd($event)"
                      />
                      <small
                        v-if="errors.length"
                        class="text-danger text-end"
                        >{{ errors[0] }}</small
                      >
                    </validation-provider>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row>
                <b-col cols="12">
                  <b-form-group>
                    <b-form-checkbox v-model="prodInHouse" id="checkbox">
                      Product Manufactured InHouse
                    </b-form-checkbox>
                  </b-form-group>
                </b-col>
              </b-row>

              <b-row class="justify-content-end">
                <!--    <b-col cols="3">
         Button Add Item 
       <b-button v-ripple.400="'rgba(113, 102, 240, 0.15)'" variant="outline-secondary" @click="resetProductModal">
          Close
        </b-button> 
      </b-col> -->
                <b-col cols="auto">
                  <!-- Button Add Item -->
                  <b-button
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    variant="primary"
                    @click="addProduct"
                  >
                    Save
                  </b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-modal>
        </validation-observer>
      </b-col>

      <!-- Right Col: Card -->
      <b-col cols="12" md="4" xl="3" class="invoice-actions mt-md-0 mt-2">
        <!-- Action Buttons -->
        <b-card>
          <!-- Button: Print -->
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="outline-primary"
            block
            @click="addInvoice"
            :disabled="loadingButton"
          >
            <b-spinner small v-if="loading"> </b-spinner>
            Save
          </b-button>
        </b-card>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import Logo from "@core/layouts/components/Logo.vue";
import Address from "@core/layouts/components/Address.vue";
import CompanyName from "@core/layouts/components/CompanyName.vue";
import { ref, onUnmounted } from "@vue/composition-api";
import { heightTransition } from "@core/mixins/ui/transition";
import Ripple from "vue-ripple-directive";

import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import { mapActions, mapGetters } from "vuex";
import {
  customLoader,
  numericValidation,
  customErrorMessage,
  allowOnlyNumbers,
} from "@/libs/customFn";
import { CurrencySymbols } from "@/libs/defaultList";
import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BButton,
  BCardText,
  BForm,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupPrepend,
  BInputGroupAppend,
  BFormTextarea,
  BFormCheckbox,
  BPopover,
  VBToggle,
  BFormSelect,
  BSpinner,
  BModal,
  BTooltip,
  BFormRadioGroup,
  VBTooltip,
} from "bootstrap-vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "@/libs/customValidation";
import { fnSortingDropdown, customError } from "@/libs/customFn";
import { useRoute } from "vue-router";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BButton,
    BFormSelect,
    BCardText,
    BForm,
    BFormGroup,
    BTooltip,
    BSpinner,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BInputGroupAppend,
    BFormTextarea,
    BFormCheckbox,
    BPopover,
    flatPickr,
    vSelect,
    Logo,
    Address,
    CompanyName,
    ValidationProvider,
    ValidationObserver,
    BModal,
    fnSortingDropdown,
    BFormRadioGroup,
  },
  directives: {
    Ripple,
    "b-toggle": VBToggle,
    "b-tooltip": VBTooltip,
  },
  data() {
    return {
      serviceOrderRef: this.$route.params.id,
      vat: JSON.parse(localStorage.getItem("userData")).vat,
      selectedProduct: null,
      productOptions: [],
      WarehouseList: [],
      index: 0,
      MaindiscountType: 0,
      discountPlaceholder: "Choose a discount type",
      MainDiscount: 0,
      item: {
        qty: 1,
      },
      config: {
        wrap: {
          wrap: true,

          minDate: new Date(),
        },
      },
      configDue: {
        wrap: {
          wrap: true,

          minDate: new Date(),
        },
      },
      loadingButton: false,
      optionsCustomer: [],
      whenSelected: [],
      whenSalePerson: [],
      optionsProduct: [],
      optionsSalesPerson: [],
      optionsWarehouse: [],
      salesPersonId: "",
      warehouseId: "",
      leadClientId: "",
      orderType: "",
      dueDate: "",
      issuedDate: Date.now(),
      note: "",
      maxDiscountValue: 100,
      tax: 0,
      discountTypeOptions: [
        { value: 0, text: "Percentage" },
        { value: 1, text: "Value" },
      ],
      ///order type
      optionsOrderType: [
        { value: null, text: "Please select an option" },
        // { value: 0, text: "Fixed Order" },
        { value: 1, text: "Variable Order" },
        { value: 2, text: "OneOff Order" },
      ],
      // add product modal
      prodName: "",
      prodQty: null,
      prodInHouse: false,
      newProd: false,

      currencyList: CurrencySymbols,
      selectedCurrency: "MUR",
      currencyOptions: [],
      exchangeRate: 1,
      barcode: null,
      loadingButton: false,
    };
  },

  mixins: [heightTransition],
  computed: {
    selectedCurrencySign() {
      return this.currencyList[this.selectedCurrency] || "Rs";
    },
    discountTotal() {
      let mainDiscount = Number(this.MainDiscount);

      if (this.MaindiscountType === 0) {
        if (mainDiscount == 0) return 0;

        return (mainDiscount / 100) * this.totalCost;
      } else {
        return mainDiscount;
      }
    },
    subTotal() {
      return this.totalCost - this.discountTotal;
    },
    VATtotal() {
      return this.salesTax;
    },
    finalTotal() {
      let total = this.vat ? this.subTotal + this.VATtotal : this.subTotal;
      return total.toFixed(2);
    },
    mainDiscountRate() {
      let mainDiscount = Number(this.MainDiscount);
      return mainDiscount / 100;
    },
    ...mapGetters("customerModule", {
      CustomerList: "customers",
      // profiledetails: "profiledetails",
      custId: "custId",
      loadingCustomer: "loading",
    }),
    ...mapGetters("productModule", {
      ProductList: "product",
      loading: "loading",
    }),
    ...mapGetters("salesPersonModule", {
      SalesPersonList: "salesperson",
      loading: "loading",
    }),

    ...mapGetters("leadModule", {
      leadList: "leads",
      leadId: "leadId",
      loadingCustomer: "loading",
    }),
    ...mapGetters("invoiceModule", {
      invoices: "invoices",
      loadingInvoice: "loading",
    }),
    ...mapGetters("warehouseModule", {
      warehouse: "warehouse",
      loading: "loading",
    }),
    ...mapGetters("serviceModule", {
      serviceOrderList: "serviceOrderList",
      loadingService: "loading",
    }),
    totalCost() {
      let total = 0;
      this.invoiceData.items.forEach((item) => {
        total += item.cost * item.qty;
      });
      if (isNaN(parseFloat(total.toFixed(2)))) {
        return 0;
      }
      return parseFloat(total.toFixed(2));
    },

    salesTax() {
      let total = 0;

      this.invoiceData.items.forEach((item) => {
        let discountAmount = item.cost * this.mainDiscountRate;
        let discountedPrice = item.cost - discountAmount;

        if (this.vat) {
          let prodsalesTax =
            discountedPrice * (parseFloat(item.tax || 0) / 100);
          total += prodsalesTax * item.qty;
        }
      });

      let totalsalesTax = parseFloat(total.toFixed(2));

      if (isNaN(totalsalesTax)) {
        return 0;
      }
      return totalsalesTax;
    },
    convertPriceRate(currentPrice) {
      return this.selectedCurrency != "MUR"
        ? currentPrice / this.exchangeRate
        : currentPrice;
    },
  },
  created() {
    window.addEventListener("resize", this.initTrHeight);
  },
  destroyed() {
    window.removeEventListener("resize", this.initTrHeight);
  },
  methods: {
    allowOnlyNumbers(event) {
      const charCode = event.which ? event.which : event.keyCode;

      if (
        (charCode < 48 || charCode > 57) &&
        charCode !== 46 &&
        charCode !== 8
      ) {
        event.preventDefault();
      }

      if (charCode === 46 && event.target.value.includes(".")) {
        event.preventDefault();
      }
    },
    populateWarehouseOptions() {
      this.optionsWarehouse = this.WarehouseList.map((v) => ({
        value: v.id,
        text: v.name, // adjust field name if different
      }));
    },
  
    
    getSalesPersonName(id) {
    const opt = this.optionsSalesPerson.find(o => o.value === id);
    return opt ? opt.text : '';
  },

    populateSalesPersonOptions() {
  // Remove duplicate IDs
  const unique = new Map();

  this.SalesPersonList.forEach(v => {
    unique.set(v.id, {
      value: v.id,
      text: `${v.firstName} ${v.lastName}`
    });
  });
  this.optionsSalesPerson = Array.from(unique.values());
},

    allowOnlyNumbersProd(event) {
      const charCode = event.which ? event.which : event.keyCode;

      if (
        charCode < 48 ||
        charCode > 57 // Allow only numbers (0-9)
      ) {
        event.preventDefault();
      }
    },

    allowOnlyNumbersUnitPrice(event) {
      const key = event.key;

      // Allow editing/navigation keys
      if (
        ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"].includes(key)
      ) {
        return;
      }

      // Block negative sign
      if (key === "-") {
        event.preventDefault();
        return;
      }

      // Allow only digits 0–9
      if (!/^[0-9]$/.test(key)) {
        event.preventDefault();
      }
    },

    cleanNumberInput(eventOrValue, index) {
      let value;

      if (
        typeof eventOrValue === "string" ||
        typeof eventOrValue === "number"
      ) {
        value = String(eventOrValue);
      } else if (eventOrValue && eventOrValue.target) {
        value = eventOrValue.target.value;
      } else {
        value = "";
      }

      value = value.replace(/[^0-9.]/g, "");

      value = value.replace(/^0+(?!\.)/, "");

      value = value.replace(/-/g, "");

      if (typeof index === "number") {
        this.invoiceData.items[index].cost = value;
      }

      if (eventOrValue && eventOrValue.target) {
        eventOrValue.target.value = value;
      }
    },

    updateItemCost(index) {
      const item = this.invoiceData.items[index];

      const purchase = parseFloat(item.purchase);
      const profitPercent = item.profit ? parseFloat(item.profit) : 0;
      const taxPercent = item.tax ? parseFloat(item.tax) : 0;

      // Calculate cost
      const costBeforeProfit = purchase * (1 + taxPercent / 100);
      const profitValue = costBeforeProfit * (profitPercent / 100);
      const totalCost = costBeforeProfit + profitValue;
      // Update item cost
      this.$set(this.invoiceData.items[index], "cost", parseFloat(totalCost));
    },
    async validateCurrencyRate() {
      let isValid = await this.$refs.quote.validate({ field: "exchangeRate" });

      if (isValid && this.exchangeRate && this.invoiceData.items.length > 0) {
        this.updateInvoiceDataOnRateChange();
      }
      return isValid;
    },
    errorAdd(error) {
      console.log("🚀 ~ errorAdd ~ error:", error);
      this.$swal({
        title: "Error!",
        text: error.response.data.message,
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    ensureNotNull(index) {
      if (
        this.items[index].discount == null ||
        this.items[index].discount === ""
      ) {
        this.items[index].discount = 0;
      }
    },
    ensureMainDiscountNotNull() {
      if (this.MainDiscount == null || this.MainDiscount === "") {
        this.MainDiscount = 0;
      }
      this.formatDiscount();
    },
    formatDiscount() {
      if (this.MainDiscount) {
        this.MainDiscount = parseFloat(this.MainDiscount).toFixed(2);
      }
    },
    validateDiscount(index) {
      if (
        this.invoiceData.items[index].discountType === 0 &&
        this.invoiceData.items[index].discount > 100
      ) {
        this.$set(this.invoiceData.items[index], "discount", 100);
      } else if (
        this.invoiceData.items[index].discountType === 1 &&
        this.invoiceData.items[index].discount >
          this.invoiceData.items[index].cost * this.invoiceData.items[index].qty
      ) {
        this.$swal({
          title: "Error!",
          html: " Discount cannot exceed total item cost. Discount was set to equal total item cost.",
          icon: "error",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
        this.$set(
          this.invoiceData.items[index],
          "discount",
          this.invoiceData.items[index].cost * this.invoiceData.items[index].qty
        );
      }
    },

    itemCost(cost, qty, discountType, discount) {
      cost = Number(cost);
      qty = Number(qty);
      discount = Number(discount);

      if (isNaN(cost) || isNaN(qty) || isNaN(discount)) {
        return "0.00";
      }

      let result = cost * qty;

      if (discountType == 0) {
        let discountAmount = result * (discount / 100);

        // Check if discountAmount is greater than the cost of all items
        if (discountAmount > result) {
          console.warn(
            "Discount cannot exceed total item cost. Discount was set to equal total item cost."
          );
          discountAmount = result;
        }
        result = result - discountAmount;
      } else if (discountType == 1) {
        // Check if flat discount is greater than the cost of all items
        if (discount > result) {
          console.warn(
            "Discount cannot exceed total item cost. Discount was set to equal total item cost."
          );
          discount = result;
        }
        result = result - discount;
      }
      return result.toFixed(2);
    },
    ...mapActions("customerModule", [
      "getCustomersListAction",
      "getCustomersByIDAction", // "getCustomerProfileDetailAction"
    ]),
    ...mapActions("productModule", [
      "getProductListAction",
      "addProductAction",
    ]),
    ...mapActions("salesPersonModule", ["getSalesPersonListAction"]),
    ...mapActions("invoiceModule", ["addInvoicesAction"]),
    ...mapActions("serviceModule", ["getServiceOrderListAction"]),
    // add product modal start
    async resetProductModal() {
      this.prodName = "";
      this.prodQty = null;
      this.prodInHouse = false;
      this.newProd = false;
      this.$refs.addProductModal.hide();
    },

    async addProduct() {
      let isValid = await this.$refs.addProduct.validate();

      if (isValid) {
        let payload = {
          name: this.prodName,
          initialQuantity: this.prodQty,
          inHouseManufactured: this.prodInHouse,
        };

        try {
          await this.addProductAction({ product: payload });

          await this.$swal({
            title: "Products!",
            text: "You have successfully added the product!",
            icon: "success",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });

          this.newProd = true;

          this.$refs.addProductModal.hide();
          await this.loadProductList();
          await this.resetProductModal();
        } catch (ex) {
          await this.$swal({
            title: "Error!",
            html: ex.response?.data?.message || "Failed!",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            buttonsStyling: false,
          });
          await this.resetProductModal();
        }
      }
    },
    // add product modal end
    addNewItemInItemForm() {
      this.invoiceData.items.push(
        JSON.parse(JSON.stringify(this.itemFormBlankItem))
      );

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight);
        setTimeout(() => {
          this.$refs.form.style.overflow = null;
        }, 350);
      });
    },
    addItemWithBarcode() {
      if (!this.barcode) {
        return;
      }

      // Filter products by barcode
      let products = this.ProductList.filter((x) => x.barcode === this.barcode);

      // If more than one product is found, show the modal with radio buttons
      if (products && products.length > 1) {
        this.selectedProduct = products;

        // Map products to radio button options
        this.productOptions = products.map((product) => ({
          text: product.name,
          value: product.id,
        }));

        this.$bvModal.show("modal-barcode");
      } else if (products.length === 1) {
        // If only one product is found, add it directly to the invoice
        let productDetail = products[0];

        let index = this.invoiceData.items.length - 1;
        if (index >= 0 && this.invoiceData.items[index].id == undefined) {
          this.invoiceData.items.splice(index, 1);
        } else {
          this.$nextTick(() => {
            this.trAddHeight(this.$refs.row?.[0]?.offsetHeight || 300);
            setTimeout(() => {
              this.$refs.form.style.overflow = null;
            }, 350);
          });
        }

        this.invoiceData.items.push(
          JSON.parse(
            JSON.stringify({
              qty: 1,
              value: productDetail.id,
              id: {
                value: productDetail.id,
                itemTitle: `${productDetail.name}`,
              },
              itemTitle: `${productDetail.name}`,
              cost: productDetail.salePrice,
              type: "Product",
              tax: productDetail.saleTaxPercentage,
              purchase: productDetail.purchasePrice,
              profit: productDetail.markUpPercentage,
              itemId: productDetail.id,
              description: productDetail.description,
              discount: 0,
              discountType: 0,
            })
          )
        );
      }

      // Clear the barcode field
      this.barcode = null;
    },

    addProductFromModal(selectedProductId) {
      let selectedProduct = this.ProductList.find(
        (product) => product.id === selectedProductId
      );

      if (selectedProduct) {
        this.invoiceData.items.push({
          qty: 1,
          value: selectedProduct.id,
          id: {
            value: selectedProduct.id,
            itemTitle: `${selectedProduct.name}`,
          },
          itemTitle: `${selectedProduct.name}`,
          itemId: productDetail.id,
          type: "Product",
          cost: selectedProduct.salePrice,
          tax: selectedProduct.saleTaxPercentage,
          purchase: selectedProduct.purchasePrice,
          profit: selectedProduct.markUpPercentage,
          description: selectedProduct.description,
          discount: 0,
          discountType: 0,
        });

        this.item.id = selectedProduct.id;

        // Hide the modal
        this.$bvModal.hide("modal-barcode");

        this.$nextTick(() => {
          this.trAddHeight(this.$refs.row[0].offsetHeight);
          setTimeout(() => {
            this.$refs.form.style.overflow = null;
          }, 350);
        });
      }
    },

    success(id) {
      this.$swal({
        title: "Invoice Added!",
        text: "You have successfully added the Invoice!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      }).then(this.$router.push("/invoice/view/" + id));
      // .then(() => {
      //   this.$router.push("/invoice/view/" + id);
      // });
    },
    error(data) {
      let msg = null;
      if (data) msg = this.getErrorString(data.request);
      this.$swal({
        title: "Error!",
        //text: msg ?? ' Failed!',
        html: msg ?? " Failed!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    getErrorString(errors) {
      let msg = null;
      if (errors) {
        msg = "<div>";
        msg = "<p>Cannot post your request due to the following errors:</p>";
        for (var prop in errors) {
          if (
            Object.prototype.hasOwnProperty.call(errors, prop) &&
            prop !== "request"
          ) {
            msg += "<p>";
            msg += prop.replace("$.", "");
            msg += ": ";
            msg += errors[prop].toString().replace("$.", "");
            msg += "</p>";
          }
        }
        msg += "</div>";
        return msg;
      }
    },
    removeItem(index) {
      this.invoiceData.items.splice(index, 1);
      this.trTrimHeight(this.$refs.row[0].offsetHeight);
    },

    updateInvoiceDataOnRateChange() {
      if (this.invoiceData.items.length > 0) {
        this.invoiceData.items.map((item, index) => {
          if (item.type !== "Product") {
            return;
          }

          let productDetail = this.ProductList.filter(
            (x) => x.id == item.value
          )[0];

          let costValue =
            this.selectedCurrency != "MUR"
              ? (productDetail.salePrice / this.exchangeRate).toFixed(2)
              : productDetail.salePrice;
          this.$set(
            this.invoiceData.items[index],
            "cost",
            parseFloat(costValue)
          );

          let purchasePrice =
            this.selectedCurrency != "MUR"
              ? (productDetail.purchasePrice / this.exchangeRate).toFixed(2)
              : productDetail.purchasePrice;
          this.$set(
            this.invoiceData.items[index],
            "purchase",
            parseFloat(purchasePrice)
          );
        });
      }

      this.prevrate = this.exchangeRate;
    },

    async addInvoice() {
      // Show Swal loader
      const loader = customLoader("Please wait while we save your invoice.");

      try {
        // Validate the form
        const isValid = await this.$refs.quote.validate();

        if (!isValid) {
          // Find the first invalid field and handle it
          const firstErrorField = this.$el.querySelector(".text-danger");
          if (firstErrorField) {
            firstErrorField.scrollIntoView({
              behavior: "smooth",
              block: "end",
              inline: "nearest",
            });
            firstErrorField.focus();
          }
          loader.close(); // Close loader when form is invalid
          return;
        }

        // Check if there are items in the invoice
        if (this.invoiceData.items.length === 0) {
          loader.close();
          this.$swal(
            "Error",
            "No items added! Please add items before creating an invoice.",
            "error"
          );
          return;
        }

        // Prepare the payload
        const payload = {
          leadClientId: this.leadClientId,
          salesPersonId: this.salesPersonId,
          warehouseId: this.warehouseId,
          dueDate: this.dueDate,
          notes: this.note,
          status: 0,
          discount: this.discountTotal,
          discountType:
            this.MaindiscountType !== null
              ? String(this.MaindiscountType)
              : "0",
          paymentMethod: "string",
          subTotal: this.subTotal,
          tax: this.salesTax,
          total: this.finalTotal,
          currency: this.selectedCurrency,
          rate: this.selectedCurrency === "MUR" ? 0 : this.exchangeRate,
          invoiceItem: this.invoiceData.items.map((event) => {
            let discountValue;
            if (event.discountType === 0) {
              discountValue = event.qty * event.cost * (event.discount / 100);
            } else if (event.discountType === 1) {
              discountValue = event.discount;
            } else {
              discountValue = 0;
            }
            const vat = event.tax || 0;
            return {
              itemId: event.type === "Product" ? event.value : null,
              description: event.description || "",
              cost: event.cost,
              price: event.price,
              quantity: event.qty,
              discountType: String(event.discountType),
              discount: discountValue,
              price: event.purchase,
              isActive: true,
              invoiceType: event.type,
              serviceOrderId: event.serviceOrderId,
              tax: vat,
            };
          }),
        };

        // Call the action to add the invoice
        const response = await this.addInvoicesAction(payload);

        // Handle successful response
        loader.close();
        this.loadingButton = true;
        this.success(response.data.result.id);
        this.$swal(
          "Success",
          "Invoice has been saved successfully.",
          "success"
        );
        //window.location.reload();
      } catch (error) {
        // Handle errors
        console.error("🚀 ~ addInvoice ~ error:", error);
        loader.close();
        const errorMessage =
          error.response?.data?.message ||
          "Failed to save invoice. Please try again.";
        this.$swal("Error", errorMessage, "error");
        window.location.reload();
      }
    },

    ...mapActions("leadModule", ["getLeadListAction", "getLeadByIDAction"]),
    ...mapActions("warehouseModule", ["getWarehouseListAction"]),
    // ...mapActions("customerModule", ["getCustomerProfileDetailAction"]),
    initTrHeight() {
      this.trSetHeight(null);
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form.scrollHeight);
      });
    },
    customerSelected(id) {
      this.whenSelected = null;
      this.getCustomersByIDAction(id)
        .then((response) => {
          this.whenSelected = this.custId;

          //console.log("selecteddddddd", this.whenSelected);

          let custcity = this.whenSelected.profile?.city?.name;
          // console.log("custcity", custcity);

          this.whenSelected.city = custcity ? custcity : "";
        })
        .catch((error) => {
          this.getLeadByIDAction(id).then((response) => {
            this.whenSelected = this.leadId;
          });
        });
    },

    selectedSaleman(id) {
      this.whenSalePerson = null;
      this.getSalesPersonListAction(id)
        .then((response) => {
          this.whenSalePerson = this.custId;

          //console.log("selecteddddddd", this.whenSalePerson);

          let custcity = this.whenSalePerson.profile?.city?.name;
          // console.log("custcity", custcity);

          this.whenSalePerson.city = custcity ? custcity : "";
        })
        .catch((error) => {
          this.getLeadByIDAction(id).then((response) => {
            // this.whenSalePerson = this.leadId;
          });
        });
    },

    // customerProfile(id) {
    //   // let payload = {
    //   //   id : id
    //   // }
    //   this.profiledetails = this.getCustomerProfileDetailAction(id);
    //    //console.log("idddddddd", id);

    //    //console.log("customerprofile", this.profiledetails.city.name );

    //    let city = this.profiledetails.city.name;
    //    return city ? city : "";
    // },

    async loadProductList() {
      await Promise.all([
        this.getProductListAction(true),
        this.getServiceOrderListAction("SR_COMPLETED"),
      ]);

      this.ProductList.map((v, i) => {
        if (v.type !== 4) {
          this.optionsProduct.push({
            qty: 1,
            value: v.id,
            itemTitle: `${v.name}`,
            categoryName: v.categoryName || "-", // Default to "No Category" if null
            subCategoryName: v.subCategoryName || "-", // Default to "No Subcategory" if null
            cost: v.salePrice,
            tax: v.saleTaxPercentage,
            purchase: v.purchasePrice,
            profit: v.markUpPercentage,
            description: v.description,
            type: "Product",
            serviceOrderId: null,
          });
        }
      });

      this.optionsProduct = fnSortingDropdown(
        this.optionsProduct,
        "asc",
        "itemTitle"
      );
      let serviceList = this.serviceOrderList;
      serviceList = fnSortingDropdown(serviceList, "asc", "orderTemplateName");
      serviceList.map((v) =>
        this.optionsProduct.push({
          qty: 1,
          value: v.id,
          itemTitle: `${v.orderTemplateName} - ${v.serviceReferenceNo}`,
          cost: v.price,
          tax: 0,
          purchase: v.price,
          profit: 0,
          description: "",
          type: "Service",
          serviceOrderId: v.id,
        })
      );

      this.optionsProduct = this.optionsProduct.filter(
        (item, index, self) =>
          index === self.findIndex((t) => t.value === item.value)
      );
    },
  },
  beforeMount() {
    this.getWarehouseListAction();
    this.getCustomersListAction();
    this.getLeadListAction();
    this.getSalesPersonListAction();
    this.getProductListAction(true);
  },
  async mounted() {
    this.initTrHeight();
   
    this.populateWarehouseOptions();
    if (this.warehouse == undefined || this.warehouse.length == 0)
      await this.getWarehouseListAction();

    this.warehouse.map((v, i) =>
      this.optionsWarehouse.push({
        value: v.id,
        text: `${v.name}`,
      })
    );
    this.optionsWarehouse = fnSortingDropdown(this.optionsWarehouse);
    this.currencyOptions = Object.keys(this.currencyList).map((x) => {
      return { text: x, value: x };
    });
    this.currencyOptions = fnSortingDropdown(
      this.currencyOptions,
      "asc",
      "text"
    );
    this.whenSelected = null;
    if (this.CustomerList == undefined || this.CustomerList.length == 0)
      await this.getCustomersListAction();
    if (this.leadList == undefined || this.leadList.length == 0)
      await this.getLeadListAction();
    if (this.SalesPersonList == undefined || this.SalesPersonList.length == 0)
      await this.getSalesPersonListAction();

    this.CustomerList.map((v, i) =>
      this.optionsCustomer.push({
        value: v.id,
        text: `${v.otherName} ${v.surname ?? ""}`,
        item: v,
      })
    );
    this.leadList
      .filter((v) => !v.isClient)
      .map((v, i) => {
        this.optionsCustomer.push({
          value: v.id,
          text: `${v.otherName} ${v.surname ?? ""}`,
          item: v,
        });
      });

    this.optionsCustomer = fnSortingDropdown(this.optionsCustomer);

    // this.SalesPersonList.map((v, i) =>
    //   this.optionsSalesPerson.push({
    //     value: v.id,
    //     text: `${v.firstName}` + " " + `${v.lastName}`,
    //   })
    // );

   
    this.populateSalesPersonOptions();
    this.optionsSalesPerson = fnSortingDropdown(this.optionsSalesPerson);
    await this.loadProductList();

    if (this.serviceOrderRef !== undefined && this.serviceOrderRef !== null) {
      let serviceOrder = this.serviceOrderList.filter(
        (x) => x.serviceReferenceNo == this.serviceOrderRef
      )[0];

      this.invoiceData.items[0].id = {
        value: serviceOrder.id,
        itemTitle: `${serviceOrder.orderTemplateName} - ${serviceOrder.serviceReferenceNo}`,
      };
      this.invoiceData.items[0].itemTitle = `${serviceOrder.orderTemplateName} - ${serviceOrder.serviceReferenceNo}`;
      this.invoiceData.items[0].description = `${serviceOrder.orderTemplateName}`;
      this.invoiceData.items[0].value = `${serviceOrder.orderTemplateName} - ${serviceOrder.serviceReferenceNo}`; //serviceOrder.id;
      this.invoiceData.items[0].serviceOrderId = `${serviceOrder.id}`;
      this.invoiceData.items[0].cost = serviceOrder.price;
      this.invoiceData.items[0].type = "Service";
      this.invoiceData.items[0].tax = 0;
      this.invoiceData.items[0].discount = 0;

      this.invoiceData.items[0].discountType = 0;
      this.invoiceData.items[0].item = serviceOrder;
      console.log(this.invoiceData.items);
    }
  },
  setup() {
    const itemFormBlankItem = {
      item: null,
      value: null,
      cost: 0,
      purchase: 0,
      qty: 1,
      tax: 0,
      profit: 0,
      description: "",
      discountType: 0,
      discount: 0,
      type: "Product",
    };

    const invoiceData = ref({
      id: 5037,
      client: null,

      // ? Set single Item in form for adding data
      items: [JSON.parse(JSON.stringify(itemFormBlankItem))],

      salesPerson: "",
      note: "It was a pleasure working with you and your team. We hope you will keep us in mind for future freelance projects. Thank You!",
      paymentMethod: null,
    });

    const updateItemForm = (index, val, exchangeRate, selectedCurrency) => {
      const {
        cost,
        qty,
        description,
        purchase,
        tax,
        profit,
        value,
        discount,
        discountType,
        type,
        serviceOrderId,
      } = val;
      invoiceData.value.items[index].cost =
        selectedCurrency != "MUR"
          ? (val.cost / exchangeRate).toFixed(2)
          : val.cost;

      invoiceData.value.items[index].qty = val.qty;
      invoiceData.value.items[index].value = val.value;
      invoiceData.value.items[index].type = val.type;
      invoiceData.value.items[index].serviceOrderId = `${val.serviceOrderId}`;

      if (val.discount) {
        invoiceData.value.items[index].discount =
          val.discount ?? this.MainDiscount;
        invoiceData.value.items[index].discountType =
          val.discountType ?? this.MaindiscountType;
      }

      invoiceData.value.items[index].tax = val.tax;
      invoiceData.value.items[index].profit = val.profit;
      invoiceData.value.items[index].purchase =
        selectedCurrency != "MUR"
          ? (val.purchase / exchangeRate).toFixed(2)
          : val.purchase;
      invoiceData.value.items[index].description = val.description;
    };

    return {
      invoiceData,
      updateItemForm,
      itemFormBlankItem,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.invoice-total-wrapper {
  width: 100% !important;
  max-width: 30rem !important;
}

.invoice-add-wrapper {
  .add-new-client-header {
    padding: $options-padding-y $options-padding-x;
    color: $success;

    &:hover {
      background-color: rgba($success, 0.12);
    }
  }
}
</style>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
@import "~@core/scss/base/components/variables-dark";

.text-truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.form-item-section {
  background-color: $product-details-bg;
}

.form-item-action-col {
  width: 27px;
}

#vs7__listbox {
  z-index: -1;
}

.repeater-form {
  // overflow: hidden;
  transition: 0.35s height;
}

.v-select {
  &.item-selector-title,
  &.payment-selector {
    background-color: #fff;

    .dark-layout & {
      background-color: unset;
    }
  }
}

.dark-layout {
  .form-item-section {
    background-color: $theme-dark-body-bg;

    .row .border {
      background-color: $theme-dark-card-bg;
    }
  }
}
</style>
